import type {
	ClickEventInput,
	ClickEventPayload,
	ImpressionsEventInput,
	ImpressionsEventPayload,
	ListingEventPayload,
	UseListingEventTrackingReturn
} from './types';

import { useTrackingIdentity } from '~/composables/visitorIdentity';

import { buildBaseListingEventPayload } from './buildBasePayload';

const ENDPOINT = '/api/listing-events';

function sendEvent(payload: ListingEventPayload): void {
	try {
		fetch(ENDPOINT, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify(payload),
			keepalive: true
		}).catch(() => {
			/* fire-and-forget — tracking failures must never reach the user */
		});
	} catch {
		/* fetch may throw synchronously on invalid input — also swallow */
	}
}

export function useListingEventTracking(): UseListingEventTrackingReturn {
	const getTrackingIdentity = useTrackingIdentity();

	function trackClick(input: ClickEventInput): void {
		if (!import.meta.client) return;

		const payload: ClickEventPayload = {
			...buildBaseListingEventPayload(getTrackingIdentity()),
			eventType: 'click',
			propertyId: input.propertyId,
			clickedAt: input.clickedAt,
			context: input.context
		};
		sendEvent(payload);
	}

	function trackImpressions(input: ImpressionsEventInput): void {
		if (!import.meta.client) return;
		if (input.impressions.length === 0) return;

		const payload: ImpressionsEventPayload = {
			...buildBaseListingEventPayload(getTrackingIdentity()),
			eventType: 'impression',
			context: input.context,
			impressions: input.impressions
		};
		sendEvent(payload);
	}

	return { trackClick, trackImpressions };
}
